import { createRouter, createWebHashHistory } from "vue-router";
import SearchView from "../views/SearchView.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: SearchView,
  },
  {
    path: "/s/:songbook/:id",
    component: SearchView
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
